import { Component } from '@angular/core';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { OtherService } from 'src/app/services/other.service';
import { RequestService } from 'src/app/services/request.service';


@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.scss']
})
export class TipsComponent {

  showLogin: boolean | undefined;
  superAdmin: boolean = false;
  superUser: boolean = false;
  subAdmin: boolean = false;

  constructor(
    private authorizationService: AuthorizationService,
    private req: RequestService<any>
  ) { }

  ngOnInit() {
    this.getUsersRoles();

  }

  getUsersRoles() {
    this.authorizationService.admin$.subscribe(isAdmin => {
      this.superAdmin = isAdmin
    });

    this.authorizationService.superuser$.subscribe(isSuperuser => {
      this.superUser = isSuperuser
    });

    this.authorizationService.subadmin$.subscribe(isSubadmin => {
      this.subAdmin = isSubadmin
    });
  }



}
